import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import DatePicker, { DateObject } from "react-multi-date-picker";
import TimePickerWrapper from '../../../components/Forms/Pickers/TimePicker';
import axios from 'axios';
import swal from 'sweetalert2';

const OD = ({ show, onClose, onSubmit, staffId, staffOptions, existingData = {} }) => {

    // const department = [
    //     { value: "1", label: "Management", },
    //     { value: "2", label: "Kitchen Management" },
    //     { value: "3", label: "Deliveri Mangement" },
    // ];
    // const staff = [
    //     { value: "1", label: "Siva Sakthi", },
    //     { value: "2", label: "Banu Priya" },
    //     { value: "3", label: "Deepak Kumar" },
    // ];
    // const options_del_point = [
    //     { value: "", label: "Select Delivery Point" },
    //     { value: "0", label: "Anna Nagar" },
    //     { value: "1", label: "Thallakulam" },
    //     { value: "2", label: "Anna Nagar" },
    //     { value: "3", label: "Thallakulam" },
    // ];

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const today = new DateObject();
    const staff = staffOptions.find((s) => s.id === staffId) || { name: 'Unknown', department: '-' };
    console.log('staffOptions:', staffOptions);
    console.log('staffId:', staffId);
    const [errors, setErrors] = useState({});
    const [selectedDate, setSelectedDate] = useState(null);
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [reason, setReason] = useState('');
    // const [isFocused] = useState(false);

    // useEffect(() => {
    //     if (isFocused) {
    //         console.log('The input is focused!');
    //     }
    // }, [isFocused]);

    const handleStartTimeChange = (time) => {
        console.log('Start time selected:', time);
        setStartTime(time);
    };

    const handleEndTimeChange = (time) => {
        console.log('End time selected:', time);
        setEndTime(time);
    };
    // Form submit handler
    // const handleSubmit = () => {

    //     console.log('selectedDate:', selectedDate);
    //     console.log('startTime:', startTime);
    //     console.log('endTime:', endTime);
    //     console.log('reason:', reason);

    //     if (!selectedDate || !selectedDate.isValid || !startTime || !endTime || !reason) {
    //         swal.fire('Warning', 'Please fill all the fields.', 'warning');
    //     return;
    //     }

    //     if (startTime >= endTime) {
    //         swal.fire('Warning', 'End time must be after start time.', 'warning');
    //     return;
    //     }

    //     const formattedDate = selectedDate.format('YYYY-MM-DD');


    //     // let formattedDate;
    //     // try {
    //     // formattedDate = new DateObject(selectedDate).format('YYYY-MM-DD');
    //     // } catch (error) {
    //     // swal.fire('Warning', 'Invalid date selected.', 'warning');
    //     // return;
    //     // }

    //     const attendanceData = {
    //     staff_id: staffId,
    //     date: formattedDate,
    //     start_time: startTime, // assuming TimePickerWrapper returns time in a usable format
    //     end_time: endTime,
    //     reason: reason.trim(),
    //     attendance_type: 3, // example, adapt as needed
    //     };

    //     // Call parent's onSubmit callback
    //     console.log('Submitting attendance data:', attendanceData);
    //     onSubmit(attendanceData);
    //     // Close modal
    //     onClose();

    //     // Reset form (optional)
    //     setSelectedDate(null);
    //     setStartTime('');
    //     setEndTime('');
    //     setReason('');
    // };

    useEffect(() => {
    if (existingData && show) {
        if (existingData.date) {
        setSelectedDate(new DateObject(existingData.date));
        }
        if (existingData.start_time) {
        setStartTime(existingData.start_time);
        }
        if (existingData.end_time) {
        setEndTime(existingData.end_time);
        }
        if (existingData.reason) {
        setReason(existingData.reason);
        }
    }
    }, [existingData, show]);

    const handleSubmit = () => {
        const newErrors = {};

        if (!selectedDate || !selectedDate.isValid) {
            newErrors.selectedDate = 'This Field is required.';
        }

        if (!startTime) {
            newErrors.startTime = 'This Field is required.';
        }

        if (!endTime) {
            newErrors.endTime = 'This Field is required.';
        }

        if (startTime && endTime && startTime >= endTime) {
            newErrors.timeOrder = 'End time must be after start time.';
        }

        if (!reason.trim()) {
            newErrors.reason = 'This Field is required.';
        }

        // If there are errors, stop submission
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        const formattedDate = selectedDate.format('YYYY-MM-DD');
        const attendanceData = {
            staff_id: staffId,
            date: formattedDate,
            start_time: startTime,
            end_time: endTime,
            reason: reason.trim(),
            attendance_type: 3,
        };

        onSubmit(attendanceData);
        onClose();

        // Reset
        setSelectedDate(null);
        setStartTime('');
        setEndTime('');
        setReason('');
        setErrors({});
    };

    return (
        <Modal show={show} size="md">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Mark OD Attendance</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        {/* <div className="col-lg-6 mb-2">
                            <label className="text-black font-w500 fs-7">Department<span className="required">*</span></label>
                            <Select placeholder='Select Department'
                                defaultValue={selectedOption}
                                onChange={setSelectedOption}
                                options={department}
                            />
                        </div> */}
                        {/* <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-4'>
                            <label className='text-gray-800 font-w500 fs-7'>Date</label>
                            <label className='text-danger fs-6 font-w600'>05-June-2025</label>
                        </div> */}
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-4'>
                            <label className='text-gray-800 font-w500 fs-7'>Staff</label>
                            <label className='text-black fs-6 font-w500'>{staff.name}</label>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-4'>
                            <label className='text-gray-800 font-w500 fs-7'>Department</label>
                            <label className='text-black fs-6 font-w500'>{staff.department}</label>
                        </div>
                        {/* <div className="col-lg-6 mb-2">
                            <label className="text-black font-w500 fs-7">Staff<span className="required">*</span></label>
                            <Select placeholder='Select Staff'
                                isMulti
                                defaultValue={selectedOption}
                                onChange={setSelectedOption}
                                options={staff}
                            />
                        </div> */}
                        <div className="col-lg-12 mb-3">
                            <label className="text-black font-w500 fs-7">
                                Date <span className="required">*</span>
                            </label>
                            <div className="datepicker-wrapper d-flex">
                                <div className="input-group-text bg-transparent border-0 px-0">
                                    <i className="fa-solid fa-calendar-days fs-4"></i>
                                </div>
                                <DatePicker
                                    placeholder="Select Date"
                                    value={selectedDate}
                                    onChange={(date) =>{ 
                                        console.log('Selected date:', date);
                                        setSelectedDate(date); }}
                                    format="DD-MM-YYYY"
                                    minDate={today}
                                    mapDays={({ date }) => {
                                        const day = date.weekDay.index; // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
                                        if (day === 0) {
                                        return {
                                            disabled: true,
                                            style: { color: "#ccc", textDecoration: "line-through" }, // Optional styling
                                        };
                                        }
                                    }}
                                />
                            </div>
                            {errors.selectedDate && (<div className="text-danger fs-7 mt-1">{errors.selectedDate}</div>)}
                        </div>
                        {/* <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">
                                OD Start Time <span className="required">*</span>
                            </label>
                            <div>
                                <input
                                    type="time"
                                    value={startTime || ''}
                                    onChange={(e) => {
                                        console.log('Native start time changed:', e.target.value);
                                        setStartTime(e.target.value);
                                    }}
                                    className="form-control"
                                />
                            </div>
                        </div>
                        <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">
                                OD End Time <span className="required">*</span>
                            </label>
                            <div>
                                <input
                                    type="time"
                                    value={endTime || ''}
                                    onChange={(e) => {
                                        console.log('Native End time changed:', e.target.value);
                                        setEndTime(e.target.value);
                                    }}
                                    className="form-control"
                                    />
                            </div>
                        </div> */}
                        <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">
                                OD Start Time <span className="required">*</span>
                            </label>
                            <div>
                                <TimePickerWrapper onChange={handleStartTimeChange} value={startTime} />
                                {errors.startTime && (<div className="text-danger fs-7 mt-1">{errors.startTime}</div>)}
                            </div>
                        </div>
                        <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">
                                OD End Time <span className="required">*</span>
                            </label>
                            <div>
                                <TimePickerWrapper onChange={handleEndTimeChange} value={endTime} />
                                {errors.endTime && (<div className="text-danger fs-7 mt-1">{errors.endTime}</div>)}
                                {errors.timeOrder && (<div className="text-danger fs-7 mt-1">{errors.timeOrder}</div>)}
                            </div>
                        </div>
                        <div className="col-lg-12 mb-3">
                            <label className="text-black font-w500 fs-7">Reason</label>
                            <textarea rows={8} className="form-control" name="comment" placeholder="Reason" value={reason}
                            onChange={(e) => setReason(e.target.value)} />
                            {errors.reason && (<div className="text-danger fs-7 mt-1">{errors.reason}</div>)}
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-3 mt-4 mb-4">
                        <button type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</button>
                        <button type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Mark OD Attendance</button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default OD;
